<template>
  <div class="app-girl-illustration">
    <div class="girl-wrap">
      <div class="girl-video"></div>
      <div class="girl-link"></div>

      <div class="girl-blink"></div>
      <div class="girl"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GirlIllustration',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    const blinkInterval = 3000;
    const blinkDuration = 500;

    const blinkEl = document.querySelector('.girl-wrap');

    setInterval(() => {
      blinkEl.classList.add('blink');
      removeBlink();
    }, blinkInterval);

    function removeBlink() {
      setTimeout(function() {
        blinkEl.classList.remove('blink');
      }, blinkDuration);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.app-girl-illustration {

  .girl-wrap {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .girl-wrap > div {
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .girl-wrap .girl {
    background: url('~assets/images/girl.svg') center center no-repeat;
    background-size: contain;
    z-index: 1;
  }

  .girl-wrap .girl-blink {
    background: url('~assets/images/girl-blink.svg') center center no-repeat;
    background-size: contain;
    z-index: 2;
    display: none;
  }

  .blink .girl-blink {
    display: block;
  }

  .girl-wrap .girl-video {
    position: absolute;
    width: 18%;
    height: 14%;
    background: url('~assets/images/block-1.svg') center center no-repeat;
    background-size: contain;
    top: 16%;
    left: 24%;
    z-index: 3;
    animation: flying 3s infinite ease-in-out;
  }

  .girl-wrap .girl-link {
    background: url('~assets/images/block-2.svg') center center no-repeat;
    background-size: contain;
    width: 16%;
    height: 14%;
    top: 34%;
    right: 18%;
    animation: flying 3s infinite ease-in-out;
    z-index: 3;
  }

  @keyframes flying {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
  }
}
</style>
